import { render, staticRenderFns } from "./ReadMoreLineclamp.vue?vue&type=template&id=3ff5155a&"
import script from "./ReadMoreLineclamp.vue?vue&type=script&lang=js&"
export * from "./ReadMoreLineclamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports